import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import AppLayout from "@/components/AppLayout";
import OwnerLogin from "@/pages/OwnerLogin";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Dashboard from "@/pages/Dashboard";
import Classes from "@/pages/Classes";
import Attendance from "@/pages/Attendance";
import CoachCheckin from "@/pages/CoachCheckin";
import Students from "@/pages/Students";
import Analytics from "@/pages/Analytics";
import Announcements from "@/pages/Announcements";
import Billing from "@/pages/Billing";
import SaasBilling from "@/pages/SaasBilling";
import CheckinQr from "@/pages/CheckinQr";
import Pricing from "@/pages/Pricing";
import Poster from "@/pages/Poster";
import Team from "@/pages/Team";
import StudentLayout from "@/pages/student/StudentLayout";
import StudentLogin from "@/pages/student/StudentLogin";
import StudentJoin from "@/pages/student/StudentJoin";
import StudentHome from "@/pages/student/StudentHome";
import StudentClasses from "@/pages/student/StudentClasses";
import StudentBelt from "@/pages/student/StudentBelt";
import StudentBilling from "@/pages/student/StudentBilling";
import StudentProfile from "@/pages/student/StudentProfile";
import StudentSelfCheckin from "@/pages/student/StudentSelfCheckin";
import MockCheckout from "@/pages/MockCheckout";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import AdminConsole from "@/pages/admin/AdminConsole";
import "@/App.css";

function Router() {
  const location = useLocation();
  // Synchronous check: session_id in URL fragment after OAuth → handle before any route
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/poster/:slug" element={<Poster />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/app/login" element={<OwnerLogin />} />
      <Route path="/admin" element={<AdminConsole />} />
      <Route path="/app" element={<AppLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="classes" element={<Classes />} />
        <Route path="attendance" element={<Attendance />} />
        <Route path="checkin" element={<CoachCheckin />} />
        <Route path="students" element={<Students />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="announcements" element={<Announcements />} />
        <Route path="billing" element={<Billing />} />
        <Route path="plan" element={<SaasBilling />} />
        <Route path="checkin-qr" element={<CheckinQr />} />
        <Route path="team" element={<Team />} />
      </Route>
      <Route path="/student/login" element={<StudentLogin />} />
      <Route path="/join/:slug" element={<StudentJoin />} />
      <Route path="/student" element={<StudentLayout />}>
        <Route index element={<StudentHome />} />
        <Route path="home" element={<StudentHome />} />
        <Route path="classes" element={<StudentClasses />} />
        <Route path="belt" element={<StudentBelt />} />
        <Route path="billing" element={<StudentBilling />} />
        <Route path="checkin" element={<StudentSelfCheckin />} />
        <Route path="profile" element={<StudentProfile />} />
      </Route>
      <Route path="/payment/mock-checkout" element={<MockCheckout />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Router />
      </AuthProvider>
    </BrowserRouter>
  );
}
